import { FC } from "react";

interface Props {
  title: string;
  subtitle: string;
}

export const AuthHeader: FC<Props> = ({ title, subtitle }) => (
  <div className="flex flex-col gap-2">
    <p className="text-3xl font-semibold text-black font-satoshi">{title}</p>
    <p className="text-bash font-medium text-base font-satoshi">{subtitle}</p>
  </div>
);
